import { combineReducers } from "redux";
import storeData from "./storeData";
import toast from "./toast";
import users from "./users";
import destinations from "./destinations";

export default combineReducers({ storeData, toast, users, destinations });
